import { render, staticRenderFns } from "./QuestionPaperPackageManage.vue?vue&type=template&id=30783738&scoped=true&"
import script from "./QuestionPaperPackageManage.vue?vue&type=script&lang=js&"
export * from "./QuestionPaperPackageManage.vue?vue&type=script&lang=js&"
import style0 from "./QuestionPaperPackageManage.vue?vue&type=style&index=0&id=30783738&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30783738",
  null
  
)

export default component.exports